<template>
  <div>
    <div class="content">
      <div class="recycle-primary">
        <div class="container">
          <div class="recycle-loader" v-if="!loading">
            <div class="recycle-loading">
              <!-- <img src="../../static/images/card/loader.gif" /> -->
              <h3>加载中，请稍候...</h3>
              <p>如长时间未加载成功，请刷新重试~</p>
              <p>
                <a
                  class="btn btn-default btn-sm"
                  href="javascript:location.reload();"
                  >点我刷新或Ctrl+F5</a
                >
              </p>
            </div>
            <div class="recycle-former recycle-placeholder">
              <div class="form-group">
                <div class="col-xs-11 col-xs-offset-1">
                  <ul class="btn-group btn-group-tall clearfix">
                    <li v-for="item in 8" :key="item">
                      <span class="btn btn-placeholder"></span>
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div class="form-group">
                <div class="col-xs-11 col-xs-offset-1">
                  <ul class="btn-group btn-group-value clearfix">
                    <li v-for="item in 10" :key="item">
                      <span class="btn btn-placeholder"></span>
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div class="form-group">
                <div class="col-xs-11 col-xs-offset-1">
                  <ul
                    class="btn-group btn-group-figure btn-group-units clearfix"
                  >
                    <li v-for="item in 2" :key="item">
                      <span class="btn btn-placeholder"></span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="form-group">
                <div class="col-xs-11 col-xs-offset-1">
                  <div
                    class="
                      form-control
                      form-control-textarea
                      form-control-placeholder
                    "
                  ></div>
                </div>
              </div>
              <hr />
              <div class="form-group">
                <div class="col-xs-11 col-xs-offset-1">
                  <div class="btn btn-lg btn-placeholder"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="recycle-former slowly" v-if="loading">
						<div class="recycle-mode" >
						  <div class="form-group nocode" >
<!-- 						    <div class="col-xs-1">
						      <label class="control-label">搜索卡种：</label>
						    </div> -->
						    <div class="col-xs-4" style="display: flex;float:right" >
						      <input class="form-control"  @keydown.enter="getSearch" v-model="search"  placeholder="请输入要出售的卡种" />
									<button class="btn btn-primary btn-sm btn-square px30" style="margin-left: 10px;" type="submit" @click="getSearch">搜索</button>
								</div>

								<div class="col-xs-11" v-if="searchBool" style="margin-top: 10px;margin-left: 8.33333%;float:right">
								  <ul class="btn-group btn-group-tall clearfix" v-if="searchList.length > 0">
								    <li
								      v-for="(item, index) in searchList"
								      :key="index"
								      @click="clickSearch(item)"
                      style="float: right;"
								    >
								      <a href="javascript:;" class="btn" style="height: 40px;">
								        <span class="title">{{ item.goods_name }}</span>
								      </a>
								    </li>
								  </ul>
									<p v-if="searchList.length === 0">暂无相关内容</p>
								</div>
						  </div>
						</div>
						<hr />
            <div class="form-group">
              <div class="col-xs-1">
                <label class="control-label" style="margin-top: 20px"
                  >选择卡类：</label
                >
              </div>
              <div class="col-xs-11">
                <ul class="btn-group btn-group-cardtype clearfix">
                  <li
                    @click="gainCard(index, item)"
                    v-for="(item, index) in cardList"
                    :key="index"
                    :class="{ active: index === cardIndex }"
                  >
                    <a
                      href="javascript:;"
                      style="margin-top: 20px"
                      class="btn-card"
                      :class="item.class"
                    >
                      <i class="iconfont iconfont1" :class="item.icon"></i>
                      <span>{{ item.name }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div class="form-group">
              <div class="col-xs-1">
                <label class="control-label">选择卡种：</label>
              </div>
              <div class="col-xs-11">
                <ul class="btn-group btn-group-tall clearfix">
                  <li
                    v-for="(item, index) in goodsList"
                    :key="index"
                    @click="gainFace(index, item)"
                    :class="{ active: goodsIndex === index }"
                  >
                    <a href="javascript:;" class="btn">
                      <!-- <span class="discount"> 94折 </span> -->
                      <img
                        :src="
                          item.web_image
                            ? item.web_image.file_path
                            : '../../static/logo.png'
                        "
                      />
                      <span class="title">{{ item.goods_name }}</span>
                      <i class="dispose-auto" style="display: none">维护</i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="recycle-opening">
              <div class="form-group">
                <div class="col-xs-1">
                  <label class="control-label">
                    单张面值：
                    <br />
                    <span class="text-red">不得选错&nbsp;&nbsp;&nbsp;</span>
                  </label>
                </div>
                <div class="col-xs-11 card-facevalue-box">
                  <ul class="btn-group btn-group-value clearfix">
                    <li
                      @click="gainMony(item, index)"
                      v-for="(item, index) in faceList"
                      :key="index"
                      :class="{ active: faceDetail.product_no === item.product_no }"
                    >
                      <a
                        href="javascript:;"
                        class="btn"
                        :class="{
                          active: faceDetail.product_no === item.product_no,
                          'wh-gropu': item.status != 1,
                        }"
                      >
                        <strong v-if="item.face_value != 0">{{
                          item.show?item.show:item.face_value
                        }}</strong>
                        <strong v-else>{{
                          custom ? custom : "自定义面值"
                        }}</strong>
                        <small>
                          <span v-if="item.face_value != '0.00'"
                            >￥{{
                              discount_show(
                                item.face_value * discount(item.api_discount)
                              )
                            }}</span
                          >
                          <span v-if="item.face_value === '0.00' && custom"
                            >￥{{
                              discount_show(
                                custom * discount(item.api_discount)
                              )
                            }}</span
                          >
                          <em>·</em>
                          <span class="text-red"
                            >{{ item.api_discount }}折</span
                          >
                        </small>
                        <i
                          class="dispose-auto text-dark"
                          v-if="item.status != 1"
                          >维护</i
                        >
                        <i
                          class="dispose-auto"
                          v-if="item.is_automatic === 1 && item.status === 1"
                          >自动</i
                        >
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="form-group" v-if="faceDetail.term != -1">
                <div class="col-xs-1">
                  <label class="control-label">请选择有效期：</label>
                </div>
                <div class="col-xs-11">
                  <el-date-picker
                    v-model="data_time"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="form-group">
                <div class="col-xs-1">
                  <label class="control-label">提交方式：</label>
                </div>
                <div class="col-xs-11">
                  <ul
                    class="btn-group btn-group-figure btn-group-units clearfix"
                  >
                    <li
                      @click="gainTab(1)"
                      v-if="
                        faceDetail.form_num === 1 ||
                        faceDetail.form_num === 2 ||
                        faceDetail.form_num === 3 ||
												faceDetail.form_num === 8
                      "
                      :class="{ active: tabIndex === 1 }"
                    >
                      <a class="btn" href="javascript:;">
                        <i class="iconfont icon-ERP_xiadan"></i>
                        单卡提交
                        <b></b>
                      </a>
                    </li>
                    <li
                      @click="gainTab(2)"
                      v-if="
                        (faceDetail.form_num === 1 ||
                          faceDetail.form_num === 2 ||
                          faceDetail.form_num === 3 ||
													faceDetail.form_num === 8) &&
                        faceDetail.batch_submit != 2
                      "
                      :class="{ active: tabIndex === 2 }"
                    >
                      <a class="btn" href="javascript:;">
                        <i class="iconfont icon-piliangbianji"></i>
                        批量提交
                        <b></b>
                      </a>
                    </li>
                    <li
                      @click="gainTab(3)"
                      v-if="
                        faceDetail.form_num === 4 || faceDetail.form_num === 6
                      "
                      :class="{ active: tabIndex === 3 }"
                    >
                      <a class="btn" href="javascript:;">
                        <i class="iconfont icon-tupian"></i>
                        图片提交
                        <b></b>
                      </a>
                    </li>
                    <li
                      @click="gainTab(4)"
                      v-if="faceDetail.form_num === 5"
                      :class="{ active: tabIndex === 4 }"
                    >
                      <a class="btn" href="javascript:;">
                        <i class="iconfont icon-ERP_xiadan"></i>
                        文本提交
                        <b></b>
                      </a>
                    </li>
                  </ul>
                  <p class="text-orange h4 pt10">
                    {{ faceDetail.product_desc }}
                  </p>
                </div>
              </div>
              <el-collapse-transition>
                <div class="recycle-mode" v-show="tabIndex === 1">
                  <div class="form-group nocode" v-if="faceDetail.form_num === 1 || faceDetail.form_num === 2">
                    <div class="col-xs-1">
                      <label class="control-label">输入卡号：</label>
                    </div>
                    <div class="col-xs-4">
                      <input class="form-control" :maxlength="faceDetail.card_length > 0?faceDetail.card_length:99" v-model="card" placeholder="请输入卡号" />
                    </div>
                  </div>
                  <div class="form-group nocode" v-if="faceDetail.form_num === 1 || faceDetail.form_num === 3 || faceDetail.form_num === 8">
                    <div class="col-xs-1">
                      <label class="control-label">输入卡密：</label>
                    </div>
                    <div class="col-xs-4">
                      <input class="form-control" :maxlength="faceDetail.pass_length > 0?faceDetail.pass_length:99" v-model="card_pass" placeholder="请输入卡密" />
                    </div>
                  </div>
                  <div
                    class="form-group nocode"
                    v-if="hoopList.goods_name === '瑞祥商联卡'"
                  >
                    <div class="col-xs-1">
                      <label class="control-label">输入CVV码：</label>
                    </div>
                    <div class="col-xs-4">
                      <input class="form-control" maxlength="3" v-model="cvv_pass" placeholder="请输入CVV码" />
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
              <el-collapse-transition>
                <div class="recycle-mode" v-show="tabIndex === 2">
                  <div class="form-group">
                    <div class="col-xs-1">
                      <label class="control-label">卡号/密码：</label>
                    </div>
                    <div class="col-xs-11">
                      <div class="textarea-wrapper">
                        <textarea
                          class="form-control"
                          v-model="cpVal"
                          @keyup="onInput"
                        ></textarea>
                        <div class="textarea-tips">
                          <div class="mask-black"></div>
                          <ul class="textarea-tips-list">
                            <li class="textarea-attention">
                              <i
                                class="icon-dengpao iconfont iconfont-tips"
                              ></i>
                              <p class="text-red nocode">
                                卡号与卡密之间请用
                                <strong class="text-orange">“空格”</strong>
                                隔开，
                                <br />
                                每张卡占用一行用
                                <strong class="text-orange"
                                  >"回车(Enter键)"</strong
                                >
                                隔开
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="help-block">
                        <a class="btn btn-sm btn-primary cardlist-neaten"
                          >整理卡号/密码</a
                        >
                        <span class="inline-block pl20">
                          已经输入
                          <strong class="text-red">{{cpVal.split('\n').length}}</strong>
                          张面值
                          <strong class="text-red">
                            <strong>{{faceDetail.face_value==='0.00'?custom:faceDetail.face_value}}</strong>
                            元
                          </strong>
                          的卡，每次最多可提交100张
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
              <el-collapse-transition>
                <div class="recycle-mode" v-show="tabIndex === 3">
                  <div class="form-group">
                    <div class="col-xs-1">
                      <label class="control-label">上传图片：</label>
                    </div>
                    <div class="col-xs-11">
                      <div class="uploadimg-group clearfix">
                        <el-upload
                          :action="baseUrl + '/api/upload/image'"
                          list-type="picture-card"
                          :data="{ token: token }"
                          name="iFile"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="handleRemove"
                          :on-success="handSuccess"
                          :on-exceed="handErr"
                          :multiple="true"
                          :limit="10"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible">
                          <img width="100%" :src="dialogImageUrl" alt="" />
                        </el-dialog>
                      </div>
                      <div class="help-block">
                        <p>
                          可多选，最多可同时提交
                          <strong class="text-red">10</strong>
                          张
                          <em class="upload-text"> 二维码或图片 </em>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
              <el-collapse-transition>
                <div class="recycle-mode" v-show="tabIndex === 4">
                  <div class="form-group">
                    <div class="col-xs-1">
                      <label class="control-label">请输入文本：</label>
                    </div>
                    <div class="col-xs-11">
                      <div class="textarea-wrapper">
                        <textarea class="form-control" v-model="text_tar"></textarea>
                        <div class="textarea-tips">
                          <div class="mask-black"></div>
                          <ul class="textarea-tips-list">
                            <li class="textarea-attention">
                              <i
                                class="icon-dengpao iconfont iconfont-tips"
                              ></i>
                              <p class="text-red nocode">
                                卡号与卡密之间请用
                                <strong class="text-orange">“空格”</strong>
                                隔开，
                                <br />
                                每张卡占用一行用
                                <strong class="text-orange"
                                  >"回车(Enter键)"</strong
                                >
                                隔开
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="help-block">
                        <a class="btn btn-sm btn-primary cardlist-neaten" href="javascript:;" @click="clearUp()"
                          >整理卡号/密码</a
                        >
                        <span class="inline-block pl20">
                          已经输入
                          <strong class="text-red">{{cpVal.split('\n').length}}</strong>
                          张面值
                          <strong class="text-red">
                            <strong>{{faceDetail.face_value==='0.00'?custom:faceDetail.face_value}}</strong>
                            元
                          </strong>
                          的卡，每次最多可提交100张
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
              <div class="recycle-sumbit">
                <hr />
                <div class="recycle-check">
                  <div class="form-group">
                    <div class="col-xs-11 col-xs-offset-1">
                      <label class="checkbox">
                        <input type="checkbox" :checked="affirm" />
                        <span class="checkbox-text">
                          我已阅读，理解并接受「
                          <router-link class="text-blue" :to="{path:'/deal'}">
                            卡转让协议
                          </router-link>
                          」和「
                          <router-link class="text-blue" :to="{path:'/declrea'}"
                            >礼品卡回收说明</router-link
                          >
                          」
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-xs-11 col-xs-offset-1">
                      <label class="checkbox">
                        <input type="checkbox" :checked="affirm_l" />
                        <span class="checkbox-text">
                          我已确认该
                          <span class="isCard">卡号卡密</span>
                          <strong class="text-primary">来源合法</strong>
                          ，如有问题，本人愿意承担一切法律责任。
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-xs-11 col-xs-offset-1">
                    <div class="btn btn-green btn-lg btn-sellform" @click="postSubmit">
                      确认提交卡券
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel panel-stepflow-inverse">
        <div class="container">
          <flow></flow>
        </div>
      </div>
      <hotCommon></hotCommon>
      <problemCommon></problemCommon>
      <el-dialog
        title="绑定手机号"
        :visible.sync="bindPhoneBool"
        width="420px">
      	<div class="login-modal-body">
      		<div class="signform" style="padding: 0 25px;">
      			<div class="pc-login">
              <div class="text-center">
                <img src="../../static/images/home/logo.jpg"/>
              </div>
      				<div class="login-content signform mt30"  style="padding: 0 0px;">
      					<div class="form-group">
      						<label class="control-label loginstdz" style="left: 10px;">
      							<i class="iconfont icon-yonghu"></i>
      						</label>
      						<input class="form-control" v-model="mobile" placeholder="手机号码"/>
      					</div>
      					<div class="form-group">
      						<label class="control-label loginstdz" >
      							<i class="iconfont icon-icon-"></i>
      						</label>
      						<input class="form-control" maxlength="6" v-model="code" placeholder="手机验证码"/>
      						<a href="javascript:;" class="absolute-right text-blue" @click="getCode()" :class="{disabled:time!=0}">
      							{{time === 0?'获取短信验证码':time+'秒后可重新获取'}}
      						</a>
      					</div>
      					<div class="form-group">
      						<button class="btn btn-primary btn-block" type="submit" @click="bindPhone()">立即绑定</button>
      					</div>
      				</div>
      			</div>
      		</div>
      	</div>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="orderSuccessBool"
        width="520px">
      	<div class="login-modal-body">
      		<div class="signform text-center" >
            <i class="el-icon-success" style="font-size: 100px;color: rgb(68, 212, 16);"></i>
            <h4 class="order-success-title">提交订单成功</h4>
            <div class="order-success-info">
              <p>您的订单已经成功提交，平台将尽快处理！感谢您的支持！</p>
              <p>订单进度将通过微信公众号向您实时推送，</p>
              <p>敬请关注！</p>
            </div>
            <div class="bsornvnvw">
              <el-button  type="primary" @click="orderSuccessBool = false">
                继续提交
              </el-button>
            </div>
            <div class="bsornvnvw">
              <el-button   @click="openOrder">
                查看订单
              </el-button>
            </div>
      		</div>
      	</div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import config from "../../config";
import flow from "../common/flow/index.vue";
import hotCommon from "../common/hot_topick.vue";
import problemCommon from "../common/problem/index.vue";
export default {
  name: "Home",
  data() {
    return {
      classList: [
        "btn-card-movie",
        "btn-card-ecard",
        "btn-card-oils",
        "btn-card-game",
        "btn-card-cost",
        "btn-card-video",
        "btn-card-fold",
        "btn-card-movie",
      ],
      iconList: [
        "icon-shoujichongzhitianchong",
        "icon-jiayouzhan-01",
        "icon-iconfontyouxihudong",
        "icon-gouwuche",
        "icon-wentichaoshi",
        "icon-yangshi_icon_tongyong_travel_card",
        "icon-wodemeishi0101",
        "icon-yingyinjiaocai",
      ],
      cardIndex: 0,
      goodsIndex: 0,
      faceIndex: "",
      tabIndex: 1,
      cardList: [],
      kindList: [],
      cate_id: "",
      good_id: "",
      userList: [],
      goodsList: [],
      faceList: [],
      faceDetail: [],
      hoopList: [],
      custom: "",
      dialogImageUrl: "",
      dialogVisible: false,
      bindPhoneBool:false,
      baseUrl: "",
      token: "",
      imgList: [],
      data_time: "",
      loading: false,
      affirm: true,
      affirm_l: true,
      cardpassArr: [],
      cardArr: [],
      passArr: [],
      cardpassRow: 0,
      cardRow: 0,
      passRow: 0,
      isEnter: true,
      cpVal: "",
			card:"",
			card_pass:"",
			cvv_pass:"",
			text_tar:"",
			time_number:"",
			date_now:new Date().toISOString().slice(0, 10),
			new_baty:[],
      mobile:"",
      time:0,
      code:"",
      interval:null,
			search:"",
			searchList:[],
			searchBool:false,
      orderSuccessBool:false
    };
  },
  components: {
    flow,
    hotCommon,
    problemCommon,
  },
  created() {
    this.baseUrl = config.apiUrl;
    var query = this.$route.query;
    this.cate_id = Number(query.cateid);
    this.good_id = Number(query.goodid);
    this.getCard();
    this.userList = localStorage.getItem("userInfo");
		this.token = localStorage.getItem("token");
    this.getUserList()
  },
	mounted() {
	    //设置滚动条指定
	    document.documentElement.scrollTop=0
	  },
  methods: {
    openOrder(){
      this.$router.push({
        path:"/order",
      })
    },
		clickSearch(item){
			this.cate_id = item.cate_id
			this.good_id = item.id
			this.getCard()
			this.loading = false
		},
		getSearch(){
			let token = localStorage.getItem('token')
			this.$api.searchDetail({
				goods_name:this.search,
				token:token
			}).then(res => {
				if(res.code === 1){
					this.searchList = res.data
					this.searchBool = true
				}
			})
		},
    getUserList(){
    	let token = localStorage.getItem('token')
      if(token){
        this.$api.userInfo({
        	token
        }).then(result => {
        	if(result.code === 1){
        		localStorage.setItem("userInfo",JSON.stringify(result.data))
        		this.userList = result.data
            this.bindPhoneBool = false
        	}else{
        		this.$message({
        			message: res.msg,
        			type: 'warning'
        		});
        	}
        })
      }
    },
    getCode(){
    	if(this.$fxLink.checkPhone(this.mobile)){
    		this.$message({
    			message: '手机号格式不正确',
    			type: 'warning'
    		});
    		return
    	}
    	if (this.time == 0){

    		this.$api.bindPhoneCode({
    			mobile:this.mobile,
    		}).then(res => {
    			if(res.code === 1){
    				this.$message({
    					message: res.msg,
    					type: 'success'
    				});
    				this.time = 60 ;
    				this.interval = setInterval(() => {
    					if(this.time == 0){
    						clearInterval(this.interval)
    						return
    					}
    					this.time --
    				},1000)
    			}else{
    				this.$message({
    					message: res.msg,
    					type: 'warning'
    				});
    				return
    			}

    		})
    	}
    },
    bindPhone(){
    	if(this.$fxLink.checkPhone(this.mobile)){
    		this.$message({
    			message: '手机号格式不正确',
    			type: 'warning'
    		});
    		return
    	}
    	if(!this.code){
    		this.$message({
    			message: '请输入验证码',
    			type: 'warning'
    		});
    		return
    	}
    	let token = localStorage.getItem('token')
    	this.$api.updatePhone({
    		phone:this.mobile,
    		code:this.code,
    		token: token
    	}).then(res => {
    		if(res.code === 1){
    			this.$message({
    				message: res.msg,
    				type: 'success'
    			});
          this.getUserList()

    		}else{
    			this.$message({
    				message: res.msg,
    				type: 'warning'
    			});
    		}
    	})
    },
		//批量提交 卡号考密有规则时 点击整理或者提交触发
		clearygz(){

			let str = this.cpVal;
			var arr = str.split("\n");
			if(this.faceDetail.card_length === this.faceDetail.card_short && this.faceDetail.pass_short === this.faceDetail.pass_length){
				if(str){

				}else{
					this.$message({
					  message: "请输入内容",
					  type: "warning",
					});
				}
				for(let i=0;i<arr.length;i++){
					arr[i] = arr[i].replace(/\s/g,"")
					if(arr[i]){
						let c = arr[i].substring(0,this.faceDetail.card_length)
						let d = arr[i].substring(this.faceDetail.card_length)
						arr[i] = c + ' ' + d
						if(d.length > this.faceDetail.pass_length){
							if(arr[i+1]){
								arr[i+1] = arr[i].substring(this.faceDetail.card_length+this.faceDetail.pass_length+1) + arr[i+1]
								arr[i] = arr[i].substring(0,this.faceDetail.card_length+this.faceDetail.pass_length+1)
							}else{
								arr.push(arr[i].substring(this.faceDetail.card_length+this.faceDetail.pass_length+1))
								arr[i] = arr[i].substring(0,this.faceDetail.card_length+this.faceDetail.pass_length+1)
							}
						}
					}
				}
				// 一行不够下一行自动补齐
				let pdCard = this.faceDetail.card_length+this.faceDetail.pass_length + 1
				for(let i=0;i<arr.length;i++){
					if(arr[i].length < pdCard){
						if(arr[i+1]){
							if(arr[i+1].length >= (pdCard-arr[i].length)){
								let string = arr[i+1].substring(0,pdCard-arr[i].length)
								let string1 = arr[i+1].substring(pdCard-arr[i].length)
								arr[i] = arr[i]+string
								arr[i+1] = string1
							}else{
								arr[i] = arr[i] + arr[i+1]
								arr.splice(i+1,1)
							}
						}
					}
				}
			}
			for(let i=0;i<arr.length;i++){
				if(arr[i] === '' || arr[i] === " "){
					arr.splice(i,1)
				}
			}

			let b = ''
			for(let i=0;i<arr.length;i++){
				if(i<arr.length-1){
					 b += arr[i]+'\n'
				}else{
					b += arr[i]
				}
			}
			this.cpVal = b
		},
		// 批量提交卡号卡密无规则时触发
		clearwgz(){
			if(this.faceDetail.form_num === 4 || this.faceDetail.form_num === 6 || this.faceDetail.form_num === 3 || this.faceDetail.form_num === 2){
				return
			}
			let str = this.txt;
			const replaceStr2 = (str, index, char) => {
			 return str.substring(0, index) + char + str.substring(index + 1);
			 }
			// 按空格就回车 this.txt = str.replace(/\s/g,"\n")
			var arr = str.split("\n");
			let num = 0
			let num1 = []

			for(let i=0;i<arr.length;i++){
					num1 = []
				for(let j=0;j<arr[i].length;j++){

					if(arr[i][j] === " "){
						if(j === 0 || j===arr[i].length-1){
							let b =replaceStr2(arr[i], j, '')
							arr[i] = b
							continue
						}

						num += 1
						num1.push(j)

					}
					if(num > 1){

						arr[i] = arr[i].replace(/\s/g,"")
						if(arr[i]){
								let b  = arr[i].substring(0,num1[0]) + ' ' + arr[i].substring(num1[0])
								arr[i] = b
						}
						num -= 1
					}
				}
				num = 0
			}
			let list = []
			for(let i=0;i<arr.length;i++){
				if(arr[i] != ''){
					list.push(arr[i])
				}
			}

			let b_txt = ''

			for(let i=0;i<list.length;i++){
				if(i<list.length-1){
					 b_txt += list[i] + '\n'
				}else{
					b_txt += list[i]
				}

			}

			this.cpVal = b_txt
		},
		clearUp(){
			if(this.faceDetail.form_num === 1 && this.faceDetail.card_length != 0 && this.faceDetail.pass_length != 0){
				this.clearygz()
			}else{
				this.clearwgz()
			}

		},
		postSubmit(){

			if(this.faceDetail.face_value === "0.00"){
				if(!this.custom){
					this.$message({
					  message: "请选择面值",
					  type: "warning",
					});
					return
				}
			}
			if(!this.faceDetail.product_no){
				this.$message({
				  message: "请选择面值",
				  type: "warning",
				});
				return
			}
      if(!this.token){
        this.$login({
           dialogVisible: true, // 显示弹窗
        })
        return
      }
      if(!this.userList.phone){
        this.bindPhoneBool = true
        return
      }
			if(this.tabIndex === 1 || this.tabIndex === 4){
				this.oncePostOrder()
			}else{
				this.bathPostOrder()
			}
		},
		bathPostOrder(){
			if(this.tabIndex === 2){
				if(!this.cpVal){
					this.$message({
					  message: "请输入内容",
					  type: "warning",
					});
				}
				let list = this.cpVal.split('\n')
				for(let i=0;i<list.length;i++){
					if(list[i] === '' || list[i] === " "){
						list.splice(i,1)
					}
				}
				this.cpVal = list.join('\n')
        this.new_baty = []
				for(let i=0;i<list.length;i++){
					if(this.faceDetail.form_num === 1){
						let list1 = list[i].split(' ')
						if(this.hoopList.goods_name === "京东e卡(全品类)"){
							list1[0] = list1[0].replace(/[-]/g,'')
							list1[1] = list1[1].replace(/[-]/g,'')
						}
						if(!this.bathfaceForm_num1(list1[0],list1[1],i+1)){
							return
						}
					}else if(this.faceDetail.form_num === 2){
						if(!this.bathfaceForm_num2(list[i],i+1)){
							return
						}
					}else if(this.faceDetail.form_num === 3){
						if(!this.bathfaceForm_num3(list[i],i+1)){
							return
						}
					}else if(this.faceDetail.form_num === 8){
						list[i] = list[i].replace(/[-]/g,'')
						if(!this.bathfaceForm_num3(list[i],i+1)){
							return
						}
						this.new_baty[i] = list[i] + ' ' + list[i]
					}
				}
			}else if(this.tabIndex === 3){
				console.log(this.imgList);
				if(this.imgList.length < 1){
					this.$message({
					  message: "请选择图片",
					  type: "warning",
					});
					return
				}
				if(this.imgList.length > 10){
					this.$message({
					  message: "一次最多提交10张图片",
					  type: "warning",
					});
					return
				}
			}else{

			}
			if(this.faceDetail.term > 0){
				if(this.data_time){
					this.day_time2(this.data_time,this.date_now)
				}else{
					this.$message({
					  message: "请输入有效期",
					  type: "warning",
					});
				}
			}
			this.bathOrder()
		},
		oncePostOrder(){
			// 写完删掉测试



			if(this.hoopList.goods_name === "京东e卡(全品类)"){
				this.card = this.card.replace(/[-]/g,'')
				this.card_pass = this.card_pass.replace(/[-]/g,'')
			}
			if(this.faceDetail.form_num === 1){
				if(!this.faceForm_num1()){
					return
				}
			}else if(this.faceDetail.form_num === 2){
				if(!this.faceForm_num2()){
					return
				}
			}else if(this.faceDetail.form_num === 3){
				if(!this.faceForm_num3()){
					return
				}
			}else if(this.faceDetail.form_num === 8){
				this.card_pass = this.card_pass.replace(/[-]/g,'')
				if(!this.faceForm_num3()){

					return
				}
				this.card = this.card_pass
			}else if (this.faceDetail.form_num === 5){
				if(!this.text_tar){
					this.$message({
					  message: "请输入文本",
					  type: "warning",
					});
					return
				}
			}else{

			}
			if(this.faceDetail.term > 0){
				if(this.data_time){
					this.day_time2(this.data_time,this.date_now)
				}else{
					this.$message({
					  message: "请输入有效期",
					  type: "warning",
					});
				}
			}

			this.onceOrder()
		},
    clearnData(){
      this.imgList = []
      this.time_number = ""
      this.cpVal =  ""
      this.card = ""
      this.card_pass = ""
      this.cvv_pass = ""
      this.text_tar = ""
    },
		bathOrder(){

			let jdw = this.new_baty?this.new_baty.join(','):""
			let token = localStorage.getItem("token");
			this.$api.batchPostOrder({
				token: token,
				product_no:this.faceDetail.product_no,
				batchBuy: this.faceDetail.form_num === 8?jdw:this.faceDetail.form_num  === 4|| this.faceDetail.form_num  === 6?this.imgList.join(','):this.cpVal.split('\n').join(','),
				form_face:this.custom?this.custom:"",
				card_date: this.time_number,
				type:2
			}).then(res =>{
				if(res.code == 1){
          this.orderSuccessBool = true
          this.clearnData()
				}else{
					this.$message({
					  message: res.msg,
					  type: "error",
					});
				}
			})
		},
		onceOrder(){
			let token = localStorage.getItem("token");
      // 下次更新上传
      let validity = this.faceDetail.form_num === 7?"":this.hoopList.goods_name === '瑞祥商联卡'?this.cvv_pass:""
			this.$api.postOrder({
				token: token,
				product_no:this.faceDetail.product_no,
				card: this.card,
				card_pass: this.card_pass,
				card_date: this.time_number,
				images : "",
				texts:this.text_tar?this.text_tar:"",
				form_face:this.custom?this.custom:"",
        validity:validity,
				type:2
			}).then(res => {
				if(res.code === 1){
          this.orderSuccessBool = true
          this.clearnData()
				}else{
					this.$message({
					  message: res.msg,
					  type: "error",
					});
				}
			})
		},
		day_time2(day_inp,day_now){
			let a = day_inp.replace(/\-/g, "/") ;
			let b = day_now.replace(/\-/g, "/") ;
			a = a.split('/')
			b = b.split("/")
			let num = 0
			let num1 = 0
			let num2 = 0
			let day = 0
			if(a[0] === b[0]){

			}else{
				num = a[0]-b[0]
			}
			if(a[1] === b[1]){

			}else{
				 num1 = a[1] - b[1]
			}
			if(a[2] === b[2]){

			}else{
				 num2 = a[2] - b[2]
			}
			if(num != 0){
				day += 365*num
			}
			if(num1 !=0 ){
				day += num1 * 30
			}
			if(num2 != 0){
				day += num2
			}
			this.time_number = day
		},
		bathfaceForm_num1(card,card_pass,i){
			if(!card){
				this.$message({
				  message: "请检查第"+i+"行是否输入卡号",
				  type: "warning",
				});
				return false
			}
			if(!card_pass){
				this.$message({
				  message: "请检查第"+i+"行是否输入卡密	",
				  type: "warning",
				});
				return false
			}
			if(!this.judegType(card,1,i)){
				return false
			}
			if(!this.judegType(card_pass,2,i)){

				return false
			}
			if(!this.judgeLength(card,1,i)){

				return false
			}
			if(!this.judgeLength(card_pass,2,i)){

				return false
			}
			return true
		},
		bathfaceForm_num2(card,i){
			if(!card){
				this.$message({
				  message: "请检查第"+i+"行是否输入卡号",
				  type: "warning",
				});
				return false
			}
			if(!this.judegType(card,1,i)){
				return false
			}
			if(!this.judgeLength(card,1,i)){

				return false
			}
			return true
		},
		bathfaceForm_num3(card_pass,i){
			if(!card_pass){
				this.$message({
				  message: "请检查第"+i+"行是否输入卡密	",
				  type: "warning",
				});
				return false
			}

			if(!this.judegType(card_pass,2,i)){

				return false
			}

			if(!this.judgeLength(card_pass,2,i)){

				return false
			}
			return true
		},
		faceForm_num1(){
			if(!this.card){
				this.$message({
				  message: "请输入卡号",
				  type: "warning",
				});
				return false
			}
			if(!this.card_pass){
				this.$message({
				  message: "请输入卡密",
				  type: "warning",
				});
				return false
			}
			if(!this.judegType(this.card,1)){
				return false
			}
			if(!this.judegType(this.card_pass,2)){
				return false
			}
			if(!this.judgeLength(this.card,1)){
				return false
			}
			if(!this.judgeLength(this.card_pass,2)){
				return false
			}

			return true
		},
		faceForm_num2(){
			if(!this.card){
				this.$message({
				  message: "请输入卡号",
				  type: "warning",
				});
				return false
			}
			if(!this.judegType(this.card,1)){
				return false
			}
			if(!this.judgeLength(this.card,1)){
				return false
			}

			return true
		},
		faceForm_num3(){
			if(!this.card_pass){
				this.$message({
				  message: "请输入卡密",
				  type: "warning",
				});
				return false
			}
			if(!this.judegType(this.card_pass,2)){
				return false
			}
			if(!this.judgeLength(this.card_pass,2)){
				return false
			}

			return true
		},
		judgeLength(str,type,i){
			if(i){
				if(type === 1){
					if(this.faceDetail.card_length === 0){
						return true
					}
					let num = this.once_digit(str,type)
					if(!num){
						this.$message({
						  message: '请检查第'+i+"行卡号位数"+'卡号应为'+this.faceDetail.card_short + '位~' + this.faceDetail.card_length + '位',
						  type: "warning",
						});
						return false
					}
					return true
				}else{
					if(this.faceDetail.pass_length === 0){
						return true
					}
					let num = this.once_digit(str,type)
					if(!num){
						this.$message({
						  message: '请检查第'+i+"行卡密位数"+'卡密应为'+this.faceDetail.pass_short + '位~' + this.faceDetail.pass_length + '位',
						  type: "warning",
						});
						return false
					}
					return true
				}
			}else{
				if(type === 1){
					if(this.faceDetail.card_length === 0){
						return true
					}
					let num = this.once_digit(str,type)
					if(!num){
						this.$message({
						  message: '卡号应为'+this.faceDetail.card_short + '位~' + this.faceDetail.card_length + '位',
						  type: "warning",
						});
						return false
					}
					return true
				}else{
					if(this.faceDetail.pass_length === 0){
						return true
					}
					let num = this.once_digit(str,type)
					if(!num){
						this.$message({
						  message: '卡密应为'+this.faceDetail.pass_short + '位~' + this.faceDetail.pass_length + '位',
						  type: "warning",
						});
						return false
					}
					return true
				}
			}

		},
		judegType(str,type,i){
			if(i){
				if(type === 1){
					let num =  this.card_re(str)
					if(num){
						let msg = num === 2?'纯字母':num === 3?"纯数字":num === 4?"字母加数字":"判断错误请联系客服"
						this.$message({
						  message: "请检查第"+i+"行是否为"+msg + '的卡号',
						  type: "warning",
						});
						return false
					}
					return true
				}else{
					let num =  this.card_pass_re(str)
					if(num){
						let msg = num === 2?'纯字母':num === 3?"纯数字":num === 4?"字母加数字":"判断错误请联系客服"
						this.$message({
						  message: "请检查第"+i+"行是否为"+msg + '的卡密',
						  type: "warning",
						});
						return false
					}
					return true
				}
			}else{
				if(type === 1){
					let num =  this.card_re(str)
					if(num){
						let msg = num === 2?'纯字母':num === 3?"纯数字":num === 4?"字母加数字":"判断错误请联系客服"
						this.$message({
						  message: "请输入"+msg + '的卡号',
						  type: "warning",
						});
						return false
					}
					return true
				}else{
					let num =  this.card_pass_re(str)
					if(num){
						let msg = num === 2?'纯字母':num === 3?"纯数字":num === 4?"字母加数字":"判断错误请联系客服"
						this.$message({
						  message: "请输入"+msg + '的卡密',
						  type: "warning",
						});
						return false
					}
					return true
				}
			}

		},
		// 批量卡号卡密正则判断
		card_re(card){
			if (this.faceDetail.card_g_type == 1) {
				//1不需要规则

			} else if (this.faceDetail.card_g_type == 2) {
				//2纯字母
				let patrn = /^[a-zA-Z]*$/;
				if (!patrn.test(card)) {
					return 2
				}
			} else if (this.faceDetail.card_g_type == 3) {
				//3纯数字
				let patrn = /^[0-9]*$/;
				if (!patrn.test(card)) {
					return 3
				}
			} else if (this.faceDetail.card_g_type == 4) {
				//4字母加数字
				let patrn = /^(?![^a-zA-Z]+$)(?!\D+$).{1,}$/
				if (!patrn.test(card)) {
					return 4
				}
			}
		},
		card_pass_re(card){
			if (this.faceDetail.pass_g_type == 1) {
				//1不需要规则

			} else if (this.faceDetail.pass_g_type == 2) {
				//2纯字母
				let patrn = /^[a-zA-Z]*$/;
				if (!patrn.test(card)) {
					return 2
				}
			} else if (this.faceDetail.pass_g_type == 3) {
				//3纯数字
				let patrn = /^[0-9]*$/;
				if (!patrn.test(card)) {
					return 3
				}
			} else if (this.faceDetail.pass_g_type == 4) {
				//4字母加数字
				let patrn = /^(?![^a-zA-Z]+$)(?!\D+$).{1,}$/
				if (!patrn.test(card)) {
					return 4
				}
			}
		},
		once_digit(str,type){
			if(type === 1){
				if((this.faceDetail.card_short<=str.length && str.length<=this.faceDetail.card_length)){
					return true
				}else{
					return false
				}
			}else{
				if((this.faceDetail.pass_short<=str.length && str.length<=this.faceDetail.pass_length)){
					return true
				}else{
					return false
				}
			}

		},
    onInput() {
      if (this.faceDetail["form_num"] === 1) {
        this.checkText1(this.cpVal);
      }
      if (this.faceDetail["form_num"] === 2) {
        if (this.faceDetail["card_length"] > 0) {
          this.checkText2(this.cpVal);
        }else{
					this.cpVal =  this.cpVal.replace(/\s/g, "\n")
				}
      }
      if (this.faceDetail["form_num"] === 3 || this.faceDetail["form_num"] === 8) {
        if (this.faceDetail["pass_length"] > 0) {
          this.checkText3(this.cpVal);
        }else{
					this.cpVal =  this.cpVal.replace(/\s/g, "\n")
				}

      }
    },
    checkText1(str) {
      let rowstrs = str
        .replace(/\n/g, "")
        .replace(/\s+/g, "")
        .replace(/([^\u0000-\u00FF])/g, "")
        .replace(/-/g, "");
      let newarrys = "";
      if (
        this.faceDetail["card_length"] > 0 &&
        this.faceDetail["pass_length"] > 0 &&
        this.faceDetail["card_length"] == this.faceDetail['card_short'] &&
        this.faceDetail['pass_length'] == this.faceDetail['pass_short']
      ) {
        while (rowstrs.length > 0) {
          if (rowstrs.length >= this.faceDetail["card_length"]) {
            let cNo = rowstrs.substring(0, this.faceDetail["card_length"]);
            let cPwd = "";
            rowstrs = rowstrs.substring(this.faceDetail["card_length"]);
            if (rowstrs.length >= this.faceDetail["pass_length"]) {
              cPwd = rowstrs.substring(0, this.faceDetail["pass_length"]);
              rowstrs = rowstrs.substring(this.faceDetail["pass_length"]);
            } else {
              cPwd = rowstrs;
              rowstrs = "";
            }
            if (cPwd.length === this.faceDetail["pass_length"]) {
              newarrys += cNo + (" " + cPwd + "\n");
            } else {
              newarrys += cNo + (" " + cPwd + "");
            }
          } else {
            newarrys += rowstrs;
            rowstrs = "";
          }
        }
        this.cpVal = newarrys;
      }
    },
    checkText2(str) {
      let rowstrs = str
        .replace(/\n/g, "")
        .replace(/\s+/g, "")
        .replace(/([^\u0000-\u00FF])/g, "")
        .replace(/-/g, "");
      let newarrys = "";
      if (this.faceDetail["card_length"] > 0) {
        while (rowstrs.length > 0) {
          if (rowstrs.length >= this.faceDetail["card_length"]) {
            let cNo = rowstrs.substring(0, this.faceDetail["card_length"]);
            rowstrs = rowstrs.substring(this.faceDetail["card_length"]);
            if (cNo.length === this.faceDetail["card_length"]) {
              newarrys += cNo + "\n";
            } else {
              newarrys += cNo + "";
            }
          } else {
            newarrys += rowstrs;
            rowstrs = "";
          }
        }
        this.cpVal = newarrys;
      }
    },
    checkText3(str) {
      let rowstrs = str
        .replace(/\n/g, "")
        .replace(/\s+/g, "")
        .replace(/([^\u0000-\u00FF])/g, "")
        .replace(/-/g, "");
      let newarrys = "";
      if (this.faceDetail["pass_length"] > 0) {
        while (rowstrs.length > 0) {
          if (rowstrs.length >= this.faceDetail["pass_length"]) {
            let cPwd = rowstrs.substring(0, this.faceDetail["pass_length"]);
            rowstrs = rowstrs.substring(this.faceDetail["pass_length"]);
            if (cPwd.length === this.faceDetail["pass_length"]) {
              newarrys += cPwd + "\n";
            } else {
              newarrys += cPwd + "";
            }
          } else {
            newarrys += rowstrs;
            rowstrs = "";
          }
        }
        this.cpVal = newarrys;
      }
    },
    // 图片上传
    handleRemove(file, fileList) {
      let imgid = file.response.data.file_id;
      if (this.imgList.indexOf(imgid) != -1) {
        this.imgList.splice(this.imgList.indexOf(imgid), 1);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handSuccess(response, file, fileList) {
      this.imgList.push(response.data.file_id);
    },
    handErr() {
      this.$message({
        message: "最多上传10张图片",
        type: "warning",
      });
    },
    discount_show(price) {
      return price.toFixed(2);
    },
    discount(price) {
      let bool = false;
      let number = 0;
      for (let i = 0; i < price.length; i++) {
        if (price[i] == ".") {
          bool = true;
        }
      }
      return Number(price) / 100;
    },
    getCard() {
      let token = localStorage.getItem("token");
      this.$api
        .getCardList({
          token: token,
        })
        .then((res) => {
          if (res.code === 1) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].name === "积分兑") {
                res.data.splice(i, 1);
                continue;
              }
              if (res.data[i].cate_id === this.cate_id) {
                this.cardIndex = i;
                this.kindList = res.data[i];
              }
              res.data[i].class = this.classList[i];
              res.data[i].icon = this.iconList[i];
            }
            if (!this.cate_id) {
              this.kindList = res.data[0];
              this.cardIndex = 0;
            }
            this.cardList = res.data;
            this.getGoodsList();
          }
        });
    },
    getGoodsList() {
      this.$api
        .getGoodsList({
          cate_id: this.kindList.cate_id,
          account: this.userList ? this.userList.user_id : "",
        })
        .then((res) => {
          if (res.code === 1) {
            this.goodsList = res.data;
            for (let i = 0; i < this.goodsList.length; i++) {
              if (this.good_id === this.goodsList[i].id) {
                this.goodsIndex = i;
                this.faceList = this.goodsList[i].products;
                this.hoopList = this.goodsList[i];
              }
            }
            if (!this.good_id) {
              this.faceList = this.goodsList[0].products;
              this.hoopList = this.goodsList[0];
              this.goodsIndex = 0;
            }
            for (let i = 0; i < this.faceList.length; i++) {
              if (this.faceList[i].face_value != "0.00") {
                this.faceDetail = this.faceList[i];
                // this.faceIndex = i;

                break;
              }
            }
            this.loading = true;
          }
        });
    },
    gainpattern() {
      if (this.faceDetail.form_num === 4 || this.faceDetail.form_num === 6) {
        this.tabIndex = 3;
      } else if (
        this.faceDetail.form_num === 1 ||
        this.faceDetail.form_num === 2 ||
        this.faceDetail.form_num === 3
      ) {
        this.tabIndex = 1;
      } else if (this.faceDetail.form_num === 5) {
        this.tabIndex = 4;
      } else {
        this.tabIndex = 1;
      }
    },
    gainCard(index, item) {
      this.cardIndex = index;
      this.kindList = item;

      this.getGoodsList();
    },
    gainFace(index, item) {
      this.hoopList = item;
      this.goodsIndex = index;
      this.faceList = item.products;
      for (let i = 0; i < this.faceList.length; i++) {
        if (this.faceList[i].face_value != "0.00" && this.faceList[i].status === 1) {
          this.faceDetail = this.faceList[i];
          // this.faceIndex = i;
          break;
        }
      }
			this.empty()
    },
		empty(){
			this.card = ""
			this.card_pass = ""
			this.custom = ""
			this.text_tar = ""
			this.data_time = ""
			this.time_number = ""
			this.cpVal = ""
			this.new_baty = ""
			this.imgList = []
		},
    gainMony(item, index) {
			if(item.status != 1){
				return
			}
      if (item.face_value === "0.00") {
        this.$prompt("请输入自定义面值", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^[0-9]*$/,
          inputPlaceholder: "请输入自定义金额",
          inputErrorMessage: "数字格式输入不正确额",
        })
          .then(({ value }) => {
            this.custom = value;
          })
          .catch(() => {});
      }
      this.faceIndex = index;
      this.faceDetail = item;
      this.gainpattern();
    },
    gainTab(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="">
.wh-gropu {
  background-color: #eeeeee !important;
}
.slowly {
  animation: slowly 1.5s;
}

@keyframes slowly {
  0% {
    opacity: 0;
  }
  40% {
    opacity: 0.75;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes slowly /* Safari and Chrome */ {
  0% {
    opacity: 0;
  }
  40% {
    opacity: 0.75;
  }
  100% {
    opacity: 0;
  }
}
	.loginstdz{
		margin-top: 5px;

	}
  .order-success-title{
    font-size: 24px;
    font-weight: 600;
    margin-top: 40px;
    color: #000;
  }
  .order-success-info{
    color: #ccc;
    font-size: 14px;
    margin-top: 20px;
  }
  .bsornvnvw{
    margin-top: 30px;
  }
  .bsornvnvw + .bsornvnvw{
    margin-top: 20px;
  }
  .bsornvnvw button{
    height: 60px !important;
    width: 316px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/card/shopCard.vue